import React, { Fragment } from "react";
import SectionList, { SectionTypes } from "../sections/SectionList";
import DefaultBookmarkButton from "../bookmarks/BookmarkButton";
import TopBox, { Props as TopBoxProps } from "../common/TopBox";
import styled from "styled-components";
import SectionListWithNav, {
  flattenCMSSectionLists,
  NestedSections
} from "../sections/SectionListWithNav";
import { spacing } from "../theme";

const BookmarkButton = styled(DefaultBookmarkButton)`
  margin-left: auto;
  ${spacing("margin-bottom", 64)};
`;

export interface Props {
  _id?: string;
  name: string;
  content: (
    | {
        items?: {
          navLink?: string;
          items?: SectionTypes[];
        }[];
        _type: "sections";
      }
    | {
        items?: SectionTypes[];
        _type: "contents";
      })[];
  url: string;
  breadCrumpPath: TopBoxProps["breadCrumpPath"];
  overline?: string;
  hideBookmark?: boolean;
}

export default function AdvancedArticlePage(props: Props) {
  const { content, hideBookmark } = props;
  const renderSideBar = () => (
    <BookmarkButton
      bookmark={{
        id: props._id || props.url,
        title: props.name,
        href: props.url
      }}
      activeText="Artikel gemerkt"
    >
      Artikel merken
    </BookmarkButton>
  );
  const cmsSections = flattenCMSSectionLists(content[0] as NestedSections);
  return (
    <Fragment>
      <TopBox
        linearBackground
        title={props.name}
        overline={props.overline}
        breadCrumpPath={props.breadCrumpPath}
      />

      {content && !!content.length && content[0]._type === "contents" && (
        <SectionList
          sections={content[0].items as SectionTypes[]}
          sidebar={!hideBookmark ? renderSideBar : undefined}
          main
        />
      )}
      {content && !!content.length && content[0]._type === "sections" && (
        <SectionListWithNav
          sections={cmsSections}
          sidebar={!hideBookmark ? renderSideBar : undefined}
        />
      )}
    </Fragment>
  );
}

AdvancedArticlePage.getImages = ({ content }: Partial<Props>) => {
  let images = [];
  if (content && !!content.length && content[0]._type === "contents") {
    images = images.concat(
      SectionList.getImages({ sections: content[0].items as SectionTypes[] })
    );
  }
  if (content && !!content.length && content[0]._type === "sections") {
    const sections = flattenCMSSectionLists(content[0] as NestedSections);
    images = images.concat(SectionListWithNav.getImages({ sections }));
  }
  return images;
};
